import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { ArrowRight } from '@icons/common';

import ClientAvatar from './ClientAvatar';
import { B2BClient } from './types';

interface ClientRelationProps {
  client: Pick<B2BClient, 'id' | 'name' | 'surname' | 'fullName'>;
}

// Клиент в блоке «Связанные сущности» (заказ, заявка): по клику — страница клиента.
const ClientRelation: React.FC<ClientRelationProps> = ({ client }) => {
  const history = useHistory();

  return (
    <Relation
      type="button"
      onClick={() => history.push(`/clients/${client.id}`)}
    >
      <RelationAvatar client={client} />
      <div>
        <span>Клиент</span>
        <div>{client.fullName}</div>
      </div>
      <StyledArrowRight />
    </Relation>
  );
};

const Relation = styled.button`
  align-items: center;
  background: #fff;
  border: 0;
  border-bottom: 1px solid #edf0f2;
  cursor: pointer;
  display: grid;
  font-family: inherit;
  gap: 8px;
  grid-template-columns: 32px minmax(0, 1fr) 16px;
  padding: 12px 14px;
  text-align: left;
  width: 100%;

  &:hover {
    background: #f7f9fb;
  }

  > div:nth-child(2) {
    display: grid;
    gap: 3px;
  }

  span {
    color: #919499;
    font-size: 11px;
  }
`;

const RelationAvatar = styled(ClientAvatar)`
  height: 32px;
  width: 32px;
`;

const StyledArrowRight = styled(ArrowRight)`
  height: 14px;
  width: 14px;
`;

export default ClientRelation;
